"use client";
import useRegionAndLocale from "@/hooks/useRegionAndLocale";
import { translatePath } from "@/i18n/paths/path-translator";
import clsx from "clsx";
import Link, { type LinkProps } from "@/components/UI/Link/Link";
import { HTMLAttributes } from "react";
import styles from "./TranslatedLink.module.scss";

type Props = LinkProps &
	HTMLAttributes<HTMLAnchorElement> & {
		locale?: string;
		language?: string; // Backward compatibility
		href: string;
		onlyHref?: boolean;
		hrefPrefix?: string;
		children?: React.ReactNode;
		underlined?: boolean;
	};

export default function TranslatedLink({
	locale,
	language,
	href,
	hrefPrefix,
	children,
	onlyHref = false,
	underlined = false,
	...props
}: Props) {
	const translatedHref = getTranslatedLink({
		locale: locale || language,
		href,
		hrefPrefix,
	});

	if (onlyHref) return translatedHref;

	return (
		<Link
			href={translatedHref}
			{...props}
			className={clsx([styles.link, underlined ? styles.underlined : ""])}
		>
			{children}
		</Link>
	);
}

export const getTranslatedLink = ({
	locale: localeParam = "",
	href = "",
	hrefPrefix = "",
}) => {
	const { region, locale, lang } = useRegionAndLocale();

	let prefix = "";

	if (region !== "global") {
		prefix = hrefPrefix ? hrefPrefix : `/${region}/${lang}`;
	}

	return translatePath({
		locale: localeParam || locale,
		path: href,
		prefix: prefix,
	});
};
